import { AxiosResponse } from 'axios';

import { QueryObserverOptions, useQueryClient } from '@tanstack/react-query';
import { toastService } from '@thefarmersfront/kitchen-mobile';

import { useCodesStore } from '../../store';
import { TypeCodeState } from '../../types';
import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeGetAllWorkPartCodesResponse = {
  code: string;
  message: string;
  data: {
    workPart: TypeCodeState[];
  };
};

/** @description 모든 업무 파트 코드 조회 */
export const useGetAllWorkPartCodes = () => {
  const queryClient = useQueryClient();

  const { setWorkPartCodes } = useCodesStore((state) => state.actions);

  const handleSuccess = (response: TypeGetAllWorkPartCodesResponse) => {
    setWorkPartCodes(response?.data?.workPart ?? []);
  };

  const handleError = (error: TypeErrorFormat) => {
    toastService.addToast({ message: error.message });
    setWorkPartCodes(null);
  };

  const requestGetAllWorkPartCodes = async ({
    queryConfig,
  }: {
    queryConfig?: Omit<QueryObserverOptions<AxiosResponse<TypeGetAllWorkPartCodesResponse>>, 'queryKey' | 'queryFn'>;
  } = {}) => {
    const endpoint = '/codes/work-part';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeGetAllWorkPartCodesResponse>>({
      queryKey: ['codes', 'workPart'],
      queryFn: () => axiosInstance.get<TypeGetAllWorkPartCodesResponse>(endpoint),
      ...queryConfig,
      gcTime: 0,
    });

    return requestHelper(() => query, handleSuccess, handleError);
  };

  return requestGetAllWorkPartCodes;
};
